import {DomainObject} from 'shared/store';
import {observable, action, computed} from 'mobx';
import _ from 'lodash';
import PublicInterviewSchedule from './PublicInterviewSchedule';
import {t} from 'shared/core';

class PublicInterviewInvite extends DomainObject {
  @observable companyName;
  @observable startDate;
  @observable endDate;
  @observable interviewSchedule;
  @observable bookableSlots = [];
  @observable booked;
  @observable eventStartsAt;
  @observable videoConferencingProvider;
  @observable location;
  @observable meetingHost;

  @action merge(other) {
    super.merge(other, {
      interviewSchedule: PublicInterviewSchedule,
      _dates: ['eventStartsAt']
    });
  }

  @computed get locationView() {
    if (this.videoConferencingProvider) {
      return t(`recruiting.schedule_interview.location.video_conferencing_provider.${this.videoConferencingProvider}`);
    }

    if (this.location) {
      return t(`recruiting.schedule_interview.location.${this.location}`);
    }

    if (this.interviewSchedule.videoConferencingProvider) {
      return t(`recruiting.schedule_interview.location.video_conferencing_provider.${this.interviewSchedule.videoConferencingProvider}`);
    }

    return t(`recruiting.schedule_interview.location.${this.interviewSchedule.location}`);
  }

  @computed get interviewersView() {
    const interviewers = _.compact([this.meetingHost, ...this.interviewSchedule.interviewers]);

    return _.uniq(interviewers).join(', ');
  }

  @computed get logoUrl() {
    return _.get(this, 'links.companyLogo');
  }
}

export default PublicInterviewInvite;
